import type { ReportConstraintDtoOperator } from '../../../api/generated/models';

export type { ReportingResultDto as IReportingResult } from '../../../api/generated/models';
export type { QueryStatus, QueryType } from '../../../api/generated/models';

export interface IFilterSpecTarget {
    key: string;
    value: string;
}

interface IReportFilter {
    id: string;
    dimension: string;
    action: string;
    specTarget: IFilterSpecTarget[];
}

// Aliased from the generated spec so the operator set cannot drift from the API.
export type ReportConstraintOperator = ReportConstraintDtoOperator;

interface IReportConstraint {
    id: string;
    /** Projected column key, not the metric-picker key — see metricColumnName. */
    metric: string;
    operator: ReportConstraintOperator;
    value: number | '';
}

export interface IReport {
    _id: number | null;
    name: string;
    description: string;
    createdBy: string;
    startDate: string | null;
    endDate: string | null;
    timeAggregation: string;
    preset: string;
    reportType: 'pixel' | 'advertiser';
    dimensions: Array<{ key: string; value: string }>;
    metrics: Array<{ eventType: string; label: string }>;
    customLabels: Array<{ key: string; value: string }>;
    filters: IReportFilter[];
    constraints: IReportConstraint[];
    isRelativePeriod: boolean;
    timezone: string;
    idCampaign: string;
}

export const initialReportObj: IReport = {
    _id: null,
    name: '',
    description: '',
    createdBy: '',
    startDate: null,
    endDate: null,
    timeAggregation: 'Sum',
    preset: 'choose time preset',
    reportType: 'pixel',
    dimensions: [],
    metrics: [],
    customLabels: [],
    filters: [],
    constraints: [],
    isRelativePeriod: false,
    timezone: 'UTC',
    idCampaign: '',
};

export interface IValidationErrors {
    name?: string;
    description?: string;
    createdBy?: string;
    startDate?: string;
    endDate?: string;
    dimensions?: string;
    metrics?: string;
    idCampaign?: string;
}
